import { render, staticRenderFns } from "./TeaserListItem.vue?vue&type=template&id=4a3781e3&"
import script from "./TeaserListItem.vue?vue&type=script&lang=js&"
export * from "./TeaserListItem.vue?vue&type=script&lang=js&"
import style0 from "./TeaserListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports